// see the code column on https://alltrails-test.recurly.com/plans
enum RecurlyPlan {
  Annual = 'alltrails_pro',
  Monthly = 'alltrails_pro_monthly_599',
  AllTrailsProAnnual307Trial = 'alltrails_pro_annual_30_7trial'
}

export default RecurlyPlan;
